export function ProductsCtrl (
  $scope,
  inheritorApi,
  products
) {
  $scope.products = products;

  inheritorApi.inheritCtrl('ProductsLiteCtrl', $scope);
}
